export const environment = {
  production: true,
  apiUrl: '/core',
  hubUrl: '/core/ChangeNotificationHub',
  pandaUrl: '',
  liveUrl: '',
  defaultLanguage: 'en'
};
